const prefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";

const regularFont = {
  fontFamily: "neuehaas",
  fontWeight: 400,
  src: `local('NeueHaasDisplay-Roman'), 
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayRoman.eot'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayRoman.woff') format('woff'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayRoman.woff2') format('woff2')`,
};
const lightFont = {
  fontFamily: "neuehaas",
  fontWeight: 300,
  src: `local('NeueHaasDisplay-Light'), 
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayLightEot'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayLight.woff') format('woff'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayLight.woff2') format('woff2')`,
};
const mediumFont = {
  fontFamily: "neuehaas",
  fontWeight: 600,
  src: `local('NeueHaasDisplay-Medium'), 
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayMediu.eot'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayMediu.woff') format('woff'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayMediu.woff2') format('woff2')`,
};
const boldFont = {
  fontFamily: "neuehaas",
  fontWeight: 700,
  src: `local('NeueHaasDisplay-Bold'),
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayBold.eot'), 
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayBold.woff') format('woff'), 
  url('${prefix}/fonts/NeueHaas/NeueHaasDisplayBold.woff2') format('woff2')`,
};

export default [lightFont, mediumFont, boldFont, regularFont];
